/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsEntityInputType = require('./PictProvider-InputType-MaterialsEntitySelector.js');
const ScopedEntityData = require('./_ScopedEntityData.js');

class MaterialsLineItemSelectorInputType extends MaterialsEntityInputType
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'LineItem'; //TODO: use default options for this?
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict & { TransactionTracking: any }} */
		this.pict;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'ItemCode';
		}
		if (pInput.PictForm.Multiple)
		{
			// update the parent ".control.select" to have ".is-multiple" for proper styling
			const tmpSelectWrapper = document.querySelector(`${pHTMLSelector} ~ .field .control.select`);
			if (tmpSelectWrapper && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
		}
		const tmpResult = super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
		// sample is in charge of the family for tracking
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, null, pInput.PictForm.SampleTrackingGUID);
			return tmpResult;
		}
		return tmpResult;
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.EntityTag == null)
		{
			pInput.PictForm.EntityTag = 'ItemCode';
		}
		if (pInput.PictForm.Multiple)
		{
			// update the parent ".control.select" to have ".is-multiple" for proper styling
			const tmpSelectWrapper = document.querySelector(`${pHTMLSelector} ~ .field .control.select`);
			if (tmpSelectWrapper && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
		}
		const tmpResult = super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		if (pInput.PictForm.SampleTrackingGUID && pInput.PictForm.SampleTrackingGUID != true)
		{
			this._setTrackingGUID(pInput, pRowIndex, pInput.PictForm.SampleTrackingGUID);
			return tmpResult;
		}
		return tmpResult;
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {any} pValue
	 * @param {string} pHTMLSelector
	 * @param {number|null} pRowIndex
	 * @param {string} pEvent
	 * @param {string} pTransactionGUID
	 */
	_handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		if (!pEvent || typeof pEvent !== 'string')
		{
			return;
		}

		const [ tmpEventType, tmpTrackingGUID, tmpEventPayload ] = pEvent.split(':');

		if (tmpEventType === 'SampleChanged')
		{
			if (tmpTrackingGUID !== this._getTrackingGUID(pInput, pRowIndex))
			{
				return;
			}
			if (!this._shouldRefreshSampleJoins(pInput))
			{
				return;
			}
			const tmpLineItemAddress = this._getRecordAddress(pView, pInput, pRowIndex);
			const tmpSampleLineItemJoinAddress = pInput.PictForm.SampleLineItemJoinAddress || `${tmpLineItemAddress}_SampleJoins`;
			const tmpSampleRecord = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpEventPayload);
			const tmpRefreshEvent = `SampleLineItemJoinRefresh-${this.pict.getUUID()}`;
			if (!tmpSampleRecord || typeof tmpSampleRecord !== 'object' || Array.isArray(tmpSampleRecord))
			{
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinAddress, []);
				return;
			}
			if (!tmpSampleRecord.IDSample)
			{
				return;
			}
			pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpRefreshEvent);
			this.pict.HeadlightRestClient.getJSON(`SampleLineItemJoins/FilteredTo/FBV~IDSample~EQ~${tmpSampleRecord.IDSample}`, (pError, pRecords) =>
			{
				// A failed fetch is not evidence of "no line items". Treating it as an empty set and writing
				// that through overwrites the persisted selection on a transient network error -- and the
				// document auto-save then persists the loss with no user action. Abort instead: leave both the
				// joins address and the input value exactly as loaded.
				if (pError || !Array.isArray(pRecords))
				{
					this.log.error(`MaterialsLineItemSelectorInputType: failed to load SampleLineItemJoins for Sample ID ${tmpSampleRecord.IDSample} -- keeping the persisted value.`, { pError, pRecords });
					pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
					return;
				}
				const tmpLineItemValue = pRecords.map((pJoin) => pJoin.IDLineItem).join(',');
				// Fail-open backstop, same instinct as the entity selector's autofill-scope vet: an empty result
				// cannot be distinguished from "the joins could not be resolved", so it must not clobber a value
				// the document already carries. Only an explicit user action may empty this. A non-empty result
				// is authoritative and still corrects a stale selection.
				const tmpExistingValue = this.pict.manifest.getValueAtAddress(
					pView.getMarshalDestinationObject(), this._getRecordAddress(pView, pInput, pRowIndex, ''));
				if (tmpLineItemValue === '' && String(tmpExistingValue ?? '').trim() !== '')
				{
					this._dropSoftDeletedHeldJoins(pView, pInput, pRowIndex,
						{ Entity: 'SampleLineItemJoin', ValueField: 'IDLineItem', JoinAddress: tmpSampleLineItemJoinAddress, Value: tmpExistingValue, Label: 'MaterialsLineItemSelectorInputType' },
						(pDropped) =>
						{
							if (pDropped < 1)
							{
								this.log.warn(`MaterialsLineItemSelectorInputType: Sample ID ${tmpSampleRecord.IDSample} resolved no SampleLineItemJoins but the document carries [${tmpExistingValue}] -- keeping the persisted value.`);
							}
							pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
						});
					return;
				}
				this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinAddress, pRecords);
				// Re-binding to a different Sample replaces this input's joins wholesale. It routes through
				// setDataByInput, which enters onDataChange looking exactly like a user de-selection -- but the
				// outgoing sample's joins stay attached to that sample and are not this form's to delete.
				ScopedEntityData.beginProgrammaticLoad(this.pict);
				try
				{
					if (pRowIndex != null)
					{
						pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpLineItemValue);
					}
					else
					{
						pView.setDataByInput(pInput, tmpLineItemValue);
					}
				}
				finally
				{
					ScopedEntityData.endProgrammaticLoad(this.pict);
				}
				pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpRefreshEvent);
			});
			return;
		}

		if (tmpEventType === 'ProjectEntityDataRecords')
		{
			const tmpTarget = this._getProjectionTarget(pInput, pEvent);
			if (!tmpTarget)
			{
				return;
			}
			this._syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, tmpTarget);
			const tmpLineItemAddress = this._getRecordAddress(pView, pInput, pRowIndex);
			const tmpDocumentPolyJoinAddress = pInput.PictForm.DocumentPolyJoinAddress || `${tmpLineItemAddress}_DocumentPolyJoin`;
			const tmpDocumentPolyJoin = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpDocumentPolyJoinAddress);
			if (tmpDocumentPolyJoin && typeof tmpDocumentPolyJoin === 'object' && !Array.isArray(tmpDocumentPolyJoin))
			{
				if (!tmpTarget.DocumentPolyJoin || typeof tmpTarget.DocumentPolyJoin !== 'object' || Array.isArray(tmpTarget.DocumentPolyJoin))
				{
					tmpTarget.DocumentPolyJoin = { };
				}
				tmpTarget.DocumentPolyJoin[tmpDocumentPolyJoin.GUIDDocumentPolyJoin] = tmpDocumentPolyJoin;
			}
		}
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, null, pEvent, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		this._handleEvent(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * A de-selected LineItem takes its `SampleLineItemJoin` with it. The joins are keyed by
	 * `IDLineItem`, which is also what this input's value list holds.
	 * @param {Object} pView @param {Object} pInput @param {number|string|null} pRowIndex
	 * @param {Set<string>} pRetainedIdentities
	 * @return {Array<{ Entity: string, Record: Record<string, any> }>}
	 */
	_collectRemovedDependentRecords(pView, pInput, pRowIndex, pRetainedIdentities)
	{
		const tmpLineItemAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpJoinsAddress = pInput.PictForm.SampleLineItemJoinAddress || `${tmpLineItemAddress}_SampleJoins`;
		const tmpJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpJoinsAddress);
		if (!Array.isArray(tmpJoins))
		{
			return [ ];
		}
		const tmpRemovals = [ ];
		for (const tmpJoin of tmpJoins)
		{
			if (tmpJoin && typeof tmpJoin === 'object' && !pRetainedIdentities.has(String(tmpJoin.IDLineItem)))
			{
				tmpRemovals.push({ Entity: 'SampleLineItemJoin', Record: tmpJoin });
			}
		}
		return tmpRemovals;
	}

	/**
	 * @param {Array<Record<string, any>>} pLineItems
	 * @param {Array<Record<string, any>>} pCurrentSampleLineItemJoins
	 * @param {Record<string, any>} pSample
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number|string|null} pRowIndex
	 *
	 * @return {Array<Record<string, any>>}
	 */
	_syncSampleLineItemJoins(pLineItems, pCurrentSampleLineItemJoins, pSample, pView, pInput, pRowIndex)
	{
		const tmpUnclaimedJoins = Array.isArray(pCurrentSampleLineItemJoins) ? pCurrentSampleLineItemJoins.slice() : [ ];
		const tmpSampleLineItemJoins = [ ];
		for (const tmpLineItem of pLineItems || [])
		{
			const tmpExistingJoinIndex = tmpUnclaimedJoins.findIndex((pJoin) => pJoin.IDLineItem == tmpLineItem.IDLineItem);
			if (tmpExistingJoinIndex >= 0)
			{
				tmpSampleLineItemJoins.push(tmpUnclaimedJoins[tmpExistingJoinIndex]);
				tmpUnclaimedJoins.splice(tmpExistingJoinIndex, 1);
				continue;
			}
			const tmpNewJoin = JSON.parse(JSON.stringify(pInput.PictForm.DefaultSampleLineItemJoinRecord ||
				{
					GUIDSampleLineItemJoin: `{~D:AppData.DocumentData.ReportData.GUIDDocument~}-SLIJ-${this._getSalt(pView, pInput, pRowIndex)}`,
					IDLineItem: tmpLineItem.IDLineItem,
					RepresentedQuantity: '0.000',
				}));
			tmpNewJoin.GUIDSampleLineItemJoin += `-${tmpLineItem.IDLineItem}`;
			if (pSample && pSample.GUIDSample)
			{
				if (pSample.IDSample > 0)
				{
					tmpNewJoin.IDSample = pSample.IDSample;
				}
				else
				{
					tmpNewJoin.GUIDSample = pSample.GUIDSample;
				}
			}
			this._translateRecordTemplateFields(tmpNewJoin);

			if (!tmpNewJoin.GUIDSampleLineItemJoin)
			{
				tmpNewJoin.GUIDSampleLineItemJoin = this.pict.getUUID();
			}
			tmpSampleLineItemJoins.push(tmpNewJoin);
		}
		this._stampJoinDisplayFields(tmpSampleLineItemJoins, pLineItems);
		return tmpSampleLineItemJoins;
	}

	/**
	 * Stamp a display-only flat `LineItemUnits` onto each join row (the LineItem's unit, matched by IDLineItem) so the
	 * tabular Rep Qty Units column reads it directly as plain text — a 2nd EntityDisplay on the same LineItem doesn't
	 * render. NOT a SampleLineItemJoin column — `_syncRecordsToEntityData` MUST strip it or the upsert breaks.
	 *
	 * @param {Array<Record<string, any>>} pSampleLineItemJoins
	 * @param {Array<Record<string, any>>} pLineItems - The selected LineItem records (carry `Units`).
	 */
	_stampJoinDisplayFields(pSampleLineItemJoins, pLineItems)
	{
		if (!Array.isArray(pSampleLineItemJoins))
		{
			return;
		}
		const tmpUnitsByLineItem = { };
		for (const tmpLineItem of (pLineItems || [ ]))
		{
			if (tmpLineItem && tmpLineItem.IDLineItem != null)
			{
				tmpUnitsByLineItem[tmpLineItem.IDLineItem] = tmpLineItem.Units;
			}
		}
		for (const tmpJoin of pSampleLineItemJoins)
		{
			if (tmpJoin && typeof tmpJoin === 'object' && tmpUnitsByLineItem[tmpJoin.IDLineItem] != null)
			{
				tmpJoin.LineItemUnits = tmpUnitsByLineItem[tmpJoin.IDLineItem];
			}
		}
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {Object} pRecord - The record that was refreshed.
	 * @param {string} pRecordAddress - The address where the record was stored.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {number} [pRowIndex] - The row index. If present, this is a tabular input.
	 */
	_onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex)
	{
		const tmpLineItemAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		if (!pRecord)
		{
			pRecord = pInput.PictForm.Multiple ? [] : { };
		}
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpLineItemAddress, pRecord);
		const tmpSampleLineItemJoinsAddress = pInput.PictForm.SampleLineItemJoinAddress || `${tmpLineItemAddress}_SampleJoins`;
		let tmpSampleLineItemJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinsAddress);
		const tmpSample = this._getBoundSampleRecord(pView, pInput);
		if (!Array.isArray(tmpSampleLineItemJoins))
		{
			if (tmpSampleLineItemJoins)
			{
				this.log.error(`MaterialsLineItemSelectorInputType: SampleLineItemJoins at address ${tmpSampleLineItemJoinsAddress} is not an array`, { tmpSampleLineItemJoins });
			}
			tmpSampleLineItemJoins = [ ];
		}
		tmpSampleLineItemJoins = this._syncSampleLineItemJoins(Array.isArray(pRecord) ? pRecord : [ pRecord ], tmpSampleLineItemJoins, tmpSample, pView, pInput, pRowIndex);
		this.pict.manifest.setValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinsAddress, tmpSampleLineItemJoins);
		pView.marshalToView();
		super._onRecordRefresh(pView, pInput, pRecord, pRecordAddress, pTransactionGUID, pRowIndex);
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {number|string|null} pRowIndex - The row index of the tabular data.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {Object} pTargetObject - The `<Entity>.<GUID>` object to project into.
	 */
	_syncRecordsToEntityData(pView, pInput, pRowIndex, pTransactionGUID, pTargetObject)
	{
		const tmpLineItemAddress = this._getRecordAddress(pView, pInput, pRowIndex);
		const tmpEntityData = pTargetObject;
		if (!tmpEntityData || typeof tmpEntityData !== 'object' || Array.isArray(tmpEntityData))
		{
			return;
		}

		const tmpSampleLineItemJoinsAddress = pInput.PictForm.SampleLineItemJoinAddress || `${tmpLineItemAddress}_SampleJoins`;
		const tmpSampleLineItemJoins = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleLineItemJoinsAddress);
		if (Array.isArray(tmpSampleLineItemJoins))
		{
			if (!tmpEntityData.SampleLineItemJoin || typeof tmpEntityData.SampleLineItemJoin !== 'object' || Array.isArray(tmpEntityData.SampleLineItemJoin))
			{
				tmpEntityData.SampleLineItemJoin = { };
			}
			for (const tmpSampleLineItemJoin of tmpSampleLineItemJoins)
			{
				const tmpPersistedJoin = { ...tmpSampleLineItemJoin };
				// Display-only fields (current + legacy attempts) — NOT SampleLineItemJoin columns; would break the upsert.
				delete tmpPersistedJoin.LineItemUnits;
				delete tmpPersistedJoin.IDLineItemUnits;
				delete tmpPersistedJoin.RepQtyUnits;
				tmpEntityData.SampleLineItemJoin[tmpPersistedJoin.GUIDSampleLineItemJoin] = tmpPersistedJoin;
			}
		}
	}

	/**
	 * @param {import('./PictProvider-Select2Util.js').Select2AjaxOptions} pConfigOptions
	 * @param {Object} pView
	 * @param {Object} pInput
	 * @param {number} [pRowIndex]
	 */
	_updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex)
	{
		super._updateSelect2Options(pConfigOptions, pView, pInput, pRowIndex);
		pConfigOptions.SearchFields = pConfigOptions.SearchFields || [ 'ItemCode', 'Name' ];
		//TODO: wrap existing HandleSearchFilters if it exists?
		pConfigOptions.HandleSearchFilters = (pFilters) =>
		{
			const tmpSample = this._getBoundSampleRecord(pView, pInput);
			const tmpProjectID = tmpSample?.IDProject || this.pict.AppData.DocumentData?.ReportData?.IDProject;
			if (tmpProjectID > 0)
			{
				if (pFilters.length > 0)
				{
					//FIXME: handle existing sort instructions (FSF)
					pFilters.unshift('FOP~0~(~0');
					pFilters.push('FCP~0~)~0');
				}
				//TODO: do we want to support disabling this filter?
				pFilters.push(`FBV~IDProject~EQ~${tmpProjectID}`);
			}
			pFilters.push(`FSF~Name~ASC~0`);
			return pFilters;
		};
	}

	/**
	 * @param {Object} pView
	 * @param {Object} pInput
	 *
	 * @return {Record<string, any>|null}
	 */
	_getBoundSampleRecord(pView, pInput)
	{
		const tmpPayloadUUID = this.pict.getUUID();
		this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`PushRecord:${this._getTrackingGUID(pInput)}:TempData["${tmpPayloadUUID}"]`);

		let tmpSample = this.pict.TempData[tmpPayloadUUID];
		delete this.pict.TempData[tmpPayloadUUID];

		if (!tmpSample || typeof tmpSample !== 'object' || Array.isArray(tmpSample))
		{
			//FIXME: what we actually need is a way to find this via the tracking GUID
			const tmpSampleAddress = pInput.PictForm.SampleAddress || 'SampleID__Record';
			tmpSample = this.pict.manifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpSampleAddress);
		}
		return tmpSample;
	}
}

module.exports = MaterialsLineItemSelectorInputType;
module.exports.default_configuration = { };
